import { useSelector } from 'react-redux';

import {
  FILTER_LATITUDE,
  FILTER_LOCATION_NAME,
  FILTER_LONGITUDE,
  FILTER_POSTAL_CODE
} from 'dpl/constants/query_params';
import { removeEmptyValues } from 'dpl/shared/utils/object';

/**
 * The search's location as API params, for modules that describe the
 * buyer's region rather than their filtered result set.
 */
export default function useSearchLocationParams() {
  const { citySlug, preappliedFilters: { stateSlug, cityName } = {} } =
    useSelector(({ server }: any) => server);
  const params = useSelector(({ queryParams }: any) => queryParams);

  return removeEmptyValues({
    postal_code: params[FILTER_POSTAL_CODE],
    lat: params[FILTER_LATITUDE],
    long: params[FILTER_LONGITUDE],
    location: params[FILTER_LOCATION_NAME],
    state: stateSlug,
    city: cityName,
    city_slug: citySlug
  });
}
